import { render, staticRenderFns } from "./topPart.vue?vue&type=template&id=6a4661cc&scoped=true"
import script from "./topPart.vue?vue&type=script&lang=js"
export * from "./topPart.vue?vue&type=script&lang=js"
import style0 from "./topPart.vue?vue&type=style&index=0&id=6a4661cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4661cc",
  null
  
)

export default component.exports